import { lazy } from 'react';

const CommunityRoutes = [
    {
        label: '',
        key: 'MainLayout',
        path: '/community/',
        element: lazy(() => import('@/components/Layout/CommonLayout')),
        needJudgeRealName: true,
        realNameType: 'community',
        children: [
            {
                label: '标签列表',
                key: 'tagList',
                path: 'tagList',
                show: true,
                element: lazy(() => import('@/page/community/Home/tagList'))
            },
            {
                label: '帖子详情',
                key: 'detail',
                path: 'detail',
                show: true,
                element: lazy(() => import('@/page/community/Detail/index'))
            },
            {
                label: '主题列表',
                key: 'discussList',
                path: 'discussList',
                show: true,
                element: lazy(() => import('@/page/Discuss/DiscussList/index'))
            },
            {
                label: '新增主题帖子',
                key: 'discussAdd',
                path: 'discussAdd',
                show: true,
                element: lazy(() => import('@/page/Discuss/DiscussAdd/index'))
            },
            {
                label: '编辑主题帖子',
                key: 'discussEdit',
                path: 'discussEdit',
                show: true,
                element: lazy(() => import('@/page/Discuss/DiscussEdit/edit'))
            }
        ]
    }
];
export default CommunityRoutes;
